export function getIsTokenExpired(expireAt: number | undefined) {
    if (!expireAt) return false;
    return expireAt * 1000 < new Date().getTime();
}
